const React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
const SettingsBillingComponent = require('../modules/billing-info/index.jsx');

const SettingsBilling = createClass({

  propTypes: {
    currentAccount: PropTypes.object.isRequired
  },

  getInitialState() {
    const {currentAccount} = this.props;
    const {billingInfo} = currentAccount;
    const billingInfoList = billingInfo || [];

    return {
      billingInfoList,
      currentBillingInfoId: null
    };
  },

  render() {
    const {currentAccount} = this.props;
    const {billingInfoList, currentBillingInfoId} = this.state;
    const {role} = currentAccount;

    return (
      <div className='vf-wrapper'>
        <SettingsBillingComponent
          userRole={role}
          billingInfoList={billingInfoList}
          currentBillingInfoId={currentBillingInfoId}
          showSaveButton
        />
      </div>
    );
  }
});

export default SettingsBilling;
